export * from "./RekognitionClient";
export * from "./Rekognition";
export * from "./commands/CompareFacesCommand";
export * from "./commands/CreateCollectionCommand";
export * from "./commands/CreateProjectCommand";
export * from "./commands/CreateProjectVersionCommand";
export * from "./commands/CreateStreamProcessorCommand";
export * from "./commands/DeleteCollectionCommand";
export * from "./commands/DeleteFacesCommand";
export * from "./commands/DeleteStreamProcessorCommand";
export * from "./commands/DescribeCollectionCommand";
export * from "./commands/DescribeProjectVersionsCommand";
export * from "./commands/DescribeProjectsCommand";
export * from "./commands/DescribeStreamProcessorCommand";
export * from "./commands/DetectCustomLabelsCommand";
export * from "./commands/DetectFacesCommand";
export * from "./commands/DetectLabelsCommand";
export * from "./commands/DetectModerationLabelsCommand";
export * from "./commands/DetectTextCommand";
export * from "./commands/GetCelebrityInfoCommand";
export * from "./commands/GetCelebrityRecognitionCommand";
export * from "./commands/GetContentModerationCommand";
export * from "./commands/GetFaceDetectionCommand";
export * from "./commands/GetFaceSearchCommand";
export * from "./commands/GetLabelDetectionCommand";
export * from "./commands/GetPersonTrackingCommand";
export * from "./commands/IndexFacesCommand";
export * from "./commands/ListCollectionsCommand";
export * from "./commands/ListFacesCommand";
export * from "./commands/ListStreamProcessorsCommand";
export * from "./commands/RecognizeCelebritiesCommand";
export * from "./commands/SearchFacesCommand";
export * from "./commands/SearchFacesByImageCommand";
export * from "./commands/StartCelebrityRecognitionCommand";
export * from "./commands/StartContentModerationCommand";
export * from "./commands/StartFaceDetectionCommand";
export * from "./commands/StartFaceSearchCommand";
export * from "./commands/StartLabelDetectionCommand";
export * from "./commands/StartPersonTrackingCommand";
export * from "./commands/StartProjectVersionCommand";
export * from "./commands/StartStreamProcessorCommand";
export * from "./commands/StopProjectVersionCommand";
export * from "./commands/StopStreamProcessorCommand";
export * from "./models/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/client-rekognition/dist/es/index.js
// module id = null
// module chunks = 